export const formatTimer = (
  days: number,
  hours: number,
  minutes: number,
  seconds: number
) => {
  let strTimer = '';
  if (days >= 5) {
    strTimer = `${days} дней `;
  }
  if (days === 1) {
    strTimer = '1 день ';
  }
  if (days > 1 && days < 5) {
    strTimer = `${days} дня `;
  }
  if (hours < 10) {
    strTimer += `0${hours}:`;
  } else {
    strTimer += `${hours}:`;
  }
  if (minutes < 10) {
    strTimer += `0${minutes}:`;
  } else {
    strTimer += `${minutes}:`;
  }
  if (seconds < 10) {
    strTimer += `0${seconds}`;
  } else {
    strTimer += `${seconds}`;
  }
  return strTimer;
};
